import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Meeting} from "../../../shared/interface/meeting";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {MeetingService} from "../../../shared/services/meeting.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {IddTrainingTrainer} from "../../../shared/interface/idd-training-trainer";
import {IddTrainingTrainerService} from "../../../shared/services/idd-training-trainer.service";

@Component({
  selector: 'app-idd-trainings-trainer-details',
  templateUrl: './idd-trainings-trainer-details.component.html',
  styleUrls: ['./idd-trainings-trainer-details.component.scss']
})
export class IddTrainingsTrainerDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  iddTrainingsTrainerId: string;
  iddTrainingsTrainerObject?: IddTrainingTrainer;
  iddTrainingsTrainer: ReplaySubject<IddTrainingTrainer> = new ReplaySubject<IddTrainingTrainer>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private iddTrainingTrainerService: IddTrainingTrainerService,
    private snack: MatSnackBar,
    private dialog: MatDialog,

    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.iddTrainingsTrainerId = params.id;
        this.loadIddTrainingTrainer();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadIddTrainingTrainer(): void {
    this.iddTrainingTrainerService.get(this.iddTrainingsTrainerId).subscribe((iddTrainingTrainer: IddTrainingTrainer) => {
      this.iddTrainingsTrainer.next(iddTrainingTrainer);
      this.iddTrainingsTrainerObject = iddTrainingTrainer;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
